<template>
  <div class="content-wrap">
    <div class="header">
      <div class="title">TỔNG ĐÀI</div>
    </div>
    <el-form ref="form" label-position="left" label-width="200px">
      <el-form-item label="Kích hoạt" style="margin-bottom: 10px">
        <el-switch v-model="active" />
      </el-form-item>
      <el-form-item label="Giao thức kết nối">
        <el-select
          v-model="protocolId"
          :disabled="!active"
          clearable
          placeholder="Select"
          style="width: 50%"
          @change="onChange"
        >
          <el-option
            v-for="item in protocolIdOptions"
            :key="item.id"
            :label="item.code"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
